import Component from "./Component.js"

export default class Control extends Component {
  constructor(props, context) {
    super(props, context)
    this.classList.add("amp-icon")
    this.classList.add("amp-control")
    this.mouseFocus = false
    this.focused = false
    this.state.altText = this.altText

    this.bindHandlers(["onMouseDown", "onMouseUp", "onMouseOver", "onMouseOut", "onFocus", "onBlur", "onKeyDown", "onClick", "onChange"])
  }

  static get contextTypes() {
    return super.contextTypes
  }

  get aria() {
    return {
      "aria-label": this.title,
      role: "button"
    }
  }

  get propsList() {
    const { altText, ...props } = super.propsList
    props.className = this.className
    props.tabIndex = "0"
    props.onMouseDown = (event) => (this.props.onMouseDown || this.onMouseDown)(event)
    props.onMouseUp = (event) => (this.props.onMouseUp || this.onMouseUp)(event)
    props.onMouseOver = (event) => (this.props.onMouseOver || this.onMouseOver)(event)
    props.onMouseOut = (event) => (this.props.onMouseOut || this.onMouseOut)(event)
    props.onFocus = (event) => (this.props.onFocus || this.onFocus)(event)
    props.onBlur = (event) => (this.props.onBlur || this.onBlur)(event)
    props.onKeyDown = (event) => (this.props.onKeyDown || this.onKeyDown)(event)
    props.onClick = (event) => (this.props.onClick || this.onClick)(event)

    const aria = this.aria
    for (let key in aria) {
      props[key] = aria[key]
    }

    return props
  }

  get altText() {
    return this.props.altText || this.state.altText
  }

  get title() {
    return this.player.getLocalizedString(this.altText)
  }

  onMouseDown(event) {
    this.mouseFocus = true
  }

  onMouseUp(event) {
    this.mouseFocus = false
  }

  onMouseOver(event) {

  }

  onMouseOut(event) {

  }

  onFocus(event) {
    if (this.mouseFocus == true)
      return

    this.focused = true
    this.classList.update({"amp-focus": true})
    //Hack to Prevent overflow hidden elemnts to scroll up on tabbing
    this.player.viewComponent.scrollTop = 0
  }

  onBlur(event) {
    if (this.mouseFocus == true)
      return

    this.focused = false
    this.classList.update({"amp-focus": false})
  }

  onKeyDown(event) {
    if (this.mouseFocus == true)
      return

    this.onKeyPress(event)

    if (event.type == "keypress" && (event.keyCode == 13 || event.keyCode == 32))
      this.onAction()
  }

  onAction() {
    this.onClick()
  }

  onKeyPress(event) {

  }

  onClick(event) {

  }

  change(value) {
    const onChange = this.propsList.onChange || this.onChange
    if (typeof onChange != "function")
      return
    onChange(value)
  }

  render() {
    return (
      <button ref="element" {...this.propsList} className={this.className}>
        {this.textContent}
        {this.children}
      </button>
    )
  }
}
